import { useEffect, useRef, useState } from "react";
import api from "../../utils/api";
import httpUtil from "../../utils/httpUtil";
import { toast } from "../../utils/toast";
import { ProductDetailInfo } from "../../model_def";
import util from "../../utils/util";
import View from "../../components/Base/View";
import { Carousel } from "antd";
import Image from "../../components/Base/Image";
import Text from "../../components/Base/Text";
import './index.scss'
import Price from "../../components/Price";
import Block from "../../components/Base/Block";
import Html from "../../components/Base/Html";
import SpecificPannel, { SpecificPannelRef } from "../../components/SpecificPannel";
import EventBus from "../../utils/EventBus";
import cartMaganer from "../../manager/cart";
import userUtils from "../../manager/userUtils";
import settings from "../../manager/settings";
import CouponListPannel from "../../components/CouponListPannel";
import MetaListPanel, { MetaListPanelRef } from "../../components/MetaListPanel";
import rm from "../../utils/rm";
import Coin from "../../components/Coin";
import HolidayTip, { useHolidayTip } from "../../components/HolidayTip";

const Detail = () => {

    const [productId, setProductId] = useState<number>(0);;
    const [productInfo, setProductInfo] = useState<ProductDetailInfo>();
    const [Discounts, setDiscounts] = useState<any[]>();
    const [userSelectSpecific, setUserSelectSpecific] = useState<any>({})
    const [isSoldOut, setSoldOut] = useState<boolean>(false);
    const [loaded, setLoaded] = useState<boolean>(false);
    const [timeCountDown, setTimeCountDown] = useState<{ enable: boolean, leftTimeArray: (string | number | boolean)[] }>()

    const [currentSliderIndex, setCurrentSlideIndex] = useState<number>(0);

    const [isCollected, setCollected] = useState<boolean>(false);

    const [cartTotalCountChanging, setCartTotalCountChanging] = useState<boolean>(false);
    const [cartTotalCount, setCardTotalCount] = useState<number>(0);

    const [showHomeMenu, setShowHomeMenu] = useState<boolean>(false);

    // 加购物车动画
    const [addCartProductUrl, setAddCartProductUrl] = useState<string>('')
    const [showAddCartAimate, setShowAddCardAnimate] = useState<boolean>(false);

    const specificPannelRef = useRef<SpecificPannelRef>(null)

    const contdownTimerRef = useRef<number>(0);
    const metaListPanelRef = useRef<MetaListPanelRef>()
    const longClickTimer = useRef<number>(0);
    const { isHoloday, tip } = useHolidayTip()

    /**
     * 预购商品倒计时功能
     */
    const checkPreorderProfuct = function (productInfo: ProductDetailInfo) {
        var needCountdown = productInfo.AddToCart.AvailableForPreOrder //true;//
        var countdownTimeStr =
            productInfo.AddToCart.PreOrderAvailabilityStartDateTime //"2018-09-19T18:50:00";//
        if (needCountdown) {
            var initTimeArray = util.getStartTimeLeftArray(countdownTimeStr)
            console.log('倒计时:', initTimeArray)
            if (!initTimeArray[4]) {
                setTimeCountDown({
                    enable: true,
                    leftTimeArray: initTimeArray,
                })
                contdownTimerRef.current = setInterval(function () {
                    var timeArray = util.getStartTimeLeftArray(countdownTimeStr)
                    if (timeArray[4]) {
                        setTimeCountDown({
                            enable: false,
                            leftTimeArray: [0, '00', '00', '00', true],
                        })
                        clearInterval(contdownTimerRef.current)
                    } else {
                        setTimeCountDown({
                            enable: true,
                            leftTimeArray: timeArray,
                        })
                    }
                }, 1000) as unknown as number
            }
        }
    }

    /**
     * 加载商品详情
     */
    const loadProductInfo = function () {
        var apiUrl = api.get('productdetail', {
            id: productId,
        })
        httpUtil.request(
            apiUrl,
            function (res: any) {
                if (res.data.Success) {
                    // 处理详情html
                    var productInfo = res.data.Content as ProductDetailInfo;
                    var productDetail = productInfo.FullDescription
                    //test
                    // productInfo.ProductPrice.MaxCoinMoney = 100
                    setProductInfo(productInfo)
                    setSoldOut(productInfo.AddToCart.DisableBuyButton)
                    setLoaded(true)
                    // 预购商品倒计时
                    checkPreorderProfuct(productInfo);

                    rm.shareConfig(
                        {
                            title: productInfo.Name, // ��������
                            desc: "IT之家商城好物分享", // ��������
                            url: window.location.href, // ��������
                            imgUrl: productInfo.DefaultPictureUrl, // ����ͼ��/ͼƬ
                        },
                        function (res) {
                            console.log(res);
                        }
                    )
                } else {
                    toast.error(res.data.Msgs[0])
                }
            },
            function (res: any) {
                toast.error('加载失败，稍后再试')
            },
            'GET'
        )
    }

    /**
     * 加载用户收藏状态、优惠券信息
     */
    const loadUserExtraInfo = () => {
        httpUtil.link(
            {
                apiName: 'getproductextrainfo',
                productId: productId,
            },
            'GET',
            {},
            true,
            function (success: boolean, res: any, tips: string) {
                console.log("loadUserExtraInfo", res)
                if (success) {
                    setCollected(res.data.Content.IsFavorite)
                    setDiscounts(res.data.Content.Discounts)
                }
            }
        )
    }

    /**
     * 获取购物车
     */
    const loadCartInfo = () => {
        cartMaganer.getCartList(false, function (success: boolean, res: any, tips: string) {
            console.log("loadCartInfo", res, tips)
            if (success) {
                setCardTotalCount(res.Items.length)
            }
        })
    }

    const addFav = function () {
        userUtils.doTaskInLoginState(function (state) {
            if (state.success) {
                if (!isCollected) {
                    cartMaganer.addFav(
                        productId,
                        function (success: boolean, res: any, tips: string) {
                            if (success) {
                                setCollected(true);
                                settings.add('favListIds', productId)
                                toast.info('已添加收藏')
                            }
                        }
                    )
                } else {
                    cartMaganer.delFav(
                        productId,
                        function (success: boolean, res: any, tips: string) {
                            if (success) {
                                setCollected(false);
                                settings.remove('favListIds', productId)
                                toast.info('已取消收藏')
                            }
                        }
                    )
                }
            }
        })
    }

    useEffect(() => {
        if (productId) {
            loadProductInfo();
            loadUserExtraInfo();
        }
    }, [productId])

    useEffect(() => {
        const urlInfo = util.parasUrl(window.location.href);
        if ((urlInfo.params as any).id) {
            setProductId((urlInfo.params as any).id)
        }
        // 注册购物车变更监听
        const cartChangListener = function (listInfo: any) {
            var newCount = listInfo.Items.length
            setCartTotalCountChanging(true);
            setTimeout(function () {
                setCardTotalCount(newCount)
            }, 450)
            setTimeout(function () {
                setCartTotalCountChanging(false);
            }, 600)
        };
        EventBus.register(EventBus.names.CART_CHANGE, cartChangListener)
        loadCartInfo();
        document.title = "商品详情";
        setShowHomeMenu(window.location.href.indexOf("&internal=1") === -1)
        return () => {
            clearInterval(contdownTimerRef.current);
            EventBus.unregister(EventBus.names.CART_CHANGE, cartChangListener)
        }
    }, [])

    if (!productInfo) {
        return null;
    }
    return <View className="detail-page">
        {/* 幻灯 */}
        {!!productInfo?.PictureUrls?.length && <div style={{
            position: "relative"
        }}>
            <Carousel autoplay
                className="d-gallery"
                afterChange={(c) => {
                    setCurrentSlideIndex(c)
                }}
            >
                {productInfo?.PictureUrls.map((sliderItem, sliderIndex) => {
                    return <div onClick={() => {
                        rm.previewImage({
                            url: productInfo?.PictureUrls[currentSliderIndex],
                            imgUrls: productInfo?.PictureUrls || []
                        })
                    }}>
                        <Image className="d-gallery-img" src={sliderItem}></Image>
                    </div>
                })}

            </Carousel>
            <Text
                className="d-gallery-indicator"
            >
                {currentSliderIndex + 1 + '/' + productInfo.PictureUrls.length}
            </Text>
        </div>}
        {/*  商品名称价格信息  */}
        <View className="d-meta">
            <Text className="d-title">{productInfo.Name}</Text>
            <View className="d-price-info">

                {!!productInfo.ProductPrice.MaxCoinCount ? <div style={{
                    display: "flex",
                    alignItems: "center"
                }}>
                    <Coin count={productInfo.ProductPrice.MaxCoinCount} size={36} />
                    {productInfo.ProductPrice.MaxCoinMoney > 0 && <span>
                        <span style={{
                            marginLeft: 6,
                            marginRight: 6,
                            color: "#999"
                        }}>+</span><Price value={`¥${productInfo.ProductPrice?.MaxCoinMoney}`} size={34}></Price>
                    </span>
                    }
                    {productInfo.ProductPrice.PriceValue > 0 && productInfo.ProductPrice.MaxCoinMoney == 0 && <span style={{
                        fontSize: 13,
                        color: "#999",
                        marginLeft: 12
                    }}>
                        ( 或 <Price value={productInfo.ProductPrice?.Price} size={26}></Price> )
                    </span>}
                </div> : <Price value={productInfo.ProductPrice?.Price} size={36}></Price>}
                {productInfo.ProductPrice?.OldPrice != null && (
                    <Block>

                        <Price
                            value={productInfo.ProductPrice?.OldPrice}
                            size={26}
                            color="#bbbbbb"
                            del={true}
                            style={{
                                marginLeft: '0.375rem',
                            }}
                        ></Price>
                    </Block>
                )}
            </View>
            <View className="d-price-sale">
                {productInfo.IsShipEnabled && (
                    <View className="shipping-fee">
                        {productInfo.IsFreeShipping ? (
                            <Block>运费：包邮</Block>
                        ) : (
                            <Block>
                                运费：
                                <Price
                                    value={productInfo.ShippingFeeStr}
                                    size={30}
                                    color="#bbbbbb"
                                ></Price>
                            </Block>
                        )}


                    </View>
                )}
                {loaded && (
                    <View className="d-count-left">
                        {productInfo.ManageInventoryMethod == 0
                            ? '有货'
                            : productInfo.TotalStockQuantity > 0
                                ? '剩余：' + productInfo.TotalStockQuantity
                                : '缺货'}
                    </View>
                )}
                {loaded && (
                    <Text
                        className="d-sale-count"
                        style={{
                            display: 'none',
                        }}
                    >
                        25万月销
                    </Text>
                )}

            </View>
            {isHoloday && <>
                <HolidayTip className="holidayTipD">温馨提示：{tip}</HolidayTip>
            </>}
            <View className="btn-clear-style d-share-btn"
                onTouchStart={() => {
                    longClickTimer.current = setTimeout(() => {
                        if (userUtils.isLogin() && (userUtils.getUserInfo().ise || userUtils.getUserInfo().isc)) {
                            rm.setClipboardData(window.location.href, () => {
                                toast.info("链接已复制")
                            })
                            rm.vibrate();
                        }
                    }, 600) as unknown as any
                }}
                onTouchMove={() => {
                    clearTimeout(longClickTimer.current)
                }}
                onTouchEnd={() => {
                    clearTimeout(longClickTimer.current)
                }}
                onTouchCancel={() => {
                    clearTimeout(longClickTimer.current)
                }}
                onClick={() => {
                    rm.share(
                        {
                            title: productInfo.Name, // ��������
                            desc: "IT之家商城好物分享", // ��������
                            url: window.location.href, // ��������
                            imgUrl: productInfo.DefaultPictureUrl, // ����ͼ��/ͼƬ
                        },
                        function (res) {
                            console.log(res);
                        }
                    )
                }}>
                <Image className="d-share-btn-img" src={require("../../images/share.png")}></Image>
                <text className="d-share-btn-name">分享</text>
            </View>
            {/* <Picshare className="shareDialog" sharePicUrl={sharePicUrl}>
                <Button
                    className="btn-clear-style d-share-btn"
                    plain="true"
                    onLongtap={this.shareLongClick}
                >
                    <Image
                        className="d-share-btn-img"
                        src={require('../../images/share.png')}
                    ></Image>
                    <Text className="d-share-btn-name">分享</Text>
                </Button>
            </Picshare> */}
        </View>
        {/*  商品型号等选择  */}
        <View className="setting-style-pannel">
            {Discounts && Discounts?.length > 0 && (
                <CouponListPannel
                    onListreloadrequest={loadUserExtraInfo}
                    couponList={Discounts}
                >
                    <View className="setting-style-item show-border flex-conainer">
                        <View className="flex-grow flex-conainer coupon-list">
                            <Text className="flex-fix">领券</Text>
                            <View className="flex-conainer coupon-tag-container">
                                {Discounts?.map((item, index) => {
                                    return (
                                        <View className="coupon-menu flex-fix flex-conainer">
                                            <Image
                                                className="coupon-menu-bg coupon-menu-bg-left"
                                                src={require('../../images/coupon_left_bg.png')}
                                            ></Image>
                                            <Text className="coupon-menu-text">
                                                {item.ShortName}
                                            </Text>
                                            <Image
                                                className="coupon-menu-bg coupon-menu-bg-right"
                                                src={require('../../images/coupon_right_bg.png')}
                                            ></Image>
                                        </View>
                                    )
                                })}
                            </View>
                        </View>
                        <Image
                            className="setting-style-arrow"
                            src={require('../../images/right-arrow.png')}
                        ></Image>
                    </View>
                </CouponListPannel>
            )}
            {productInfo.ProductAttributes?.length > 0 && (
                <View
                    className="setting-style-item flex-conainer"
                    onClick={() => {
                        specificPannelRef.current?.openFor(1)
                    }}
                >
                    <Text className="flex-grow specific-des">
                        {userSelectSpecific.specificDes
                            ? userSelectSpecific.specificDes
                            : '选择商品规格'}
                    </Text>
                    <Image
                        className="setting-style-arrow"
                        src={require('../../images/right-arrow.png')}
                    ></Image>
                </View>
            )}
            {productInfo.ProductSpecifications?.length > 0 && (
                <View
                    className="setting-style-item flex-conainer"
                    onClick={() => {
                        metaListPanelRef.current?.open(productInfo.ProductSpecifications)
                    }}
                >
                    <Text className="flex-grow">产品参数</Text>
                    <Image
                        className="setting-style-arrow"
                        src={require('../../images/right-arrow.png')}
                    ></Image>
                </View>
            )}
            <View
                className="setting-style-item flex-conainer"
                style={{
                    display: 'none',
                }}
            >
                <Text className="flex-grow">发货说明</Text>
                <Image
                    className="setting-style-arrow"
                    src={require('../../images/right-arrow.png')}
                ></Image>
            </View>
        </View>
        {/*  商品详情  */}
        <View className="d-detail">
            <Text className="d-tetail-title">商品详情</Text>
            <Html html={productInfo.FullDescription}></Html>
        </View>
        {/*  下架提示  */}
        {isSoldOut && (
            <View className="soldout-tip">商品已经下架了，非常抱歉~</View>
        )}
        {/*  底部工具条  */}
        <View className="d-bottom padding-safe-area">
            <View className="d-bottom-left">
                {showHomeMenu && <View
                    className="d-bottom-btn"
                    onClick={() => {
                        rm.redirectTo({
                            url: "/?hidemenu=1&fitsystemWindow=1&keeptitle=1&isrmmp=1"
                        })
                    }}
                >
                    <Image
                        className="d-bottom-btn-img"
                        src={require(
                            '../../images/nav_index.png')
                        }
                    />
                    <Text className="d-bottom-btn-name">
                        {'首页'}
                    </Text>
                </View>}
                <View
                    className="d-bottom-btn"
                    onClick={() => {
                        addFav()
                    }}
                >
                    {isCollected ? <Image

                        className="d-bottom-btn-img"
                        src={require(
                            '../../images/bottom_bar_fav_active.png')
                        }
                    ></Image> : <Image
                        className="d-bottom-btn-img"
                        src={require(
                            '../../images/bottom_bar_fav.png')
                        }
                    ></Image>}
                    <Text className="d-bottom-btn-name">
                        {'收藏'}
                    </Text>
                </View>
                {/* <View
                    className="d-bottom-btn"
                    onClick={() => {

                    }}
                >
                    <Image
                        className="d-bottom-btn-img"
                        src={require(
                            '../../images/contact.png')
                        }
                    />
                    <Text className="d-bottom-btn-name">
                        {'客服'}
                    </Text>
                </View> */}
                <View className="d-bottom-btn" onClick={() => {
                    util.navigateTo("/onlycart?isrmmp=1&hidemenu=1")
                }}>
                    <Image
                        className={
                            'd-bottom-btn-img ' +
                            (showAddCartAimate ? 'add-cart-shake' : '')
                        }
                        src={require('../../images/nav_cart.png')}
                    ></Image>
                    {cartTotalCount > 0 && (
                        <Text
                            className={
                                'd-bottom-btn-count ' +
                                (cartTotalCountChanging
                                    ? 'd-bottom-btn-count-changing'
                                    : '')
                            }
                        >
                            {cartTotalCount}
                        </Text>
                    )}
                    <Text className="d-bottom-btn-name">购物车</Text>
                </View>
            </View>
            <View
                className={'d-bottom-right ' + (isSoldOut ? 'btn-disabled' : '')}
            >
                {timeCountDown && timeCountDown.enable ? (
                    <View className="d-bottom-preorder" onClick={() => {
                        toast.info("即将开始")
                    }}>
                        距开始还剩
                        {parseInt(`${timeCountDown.leftTimeArray[0] || '0'}`) > 0 && (
                            <Block>
                                <Text className="time-count-num">
                                    {timeCountDown.leftTimeArray[0]}
                                </Text>
                                天
                            </Block>
                        )}
                        <Text className="time-count-num">
                            {timeCountDown.leftTimeArray[1]}
                        </Text>
                        :
                        <Text className="time-count-num">
                            {timeCountDown.leftTimeArray[2]}
                        </Text>
                        :
                        <Text className="time-count-num">
                            {timeCountDown.leftTimeArray[3]}
                        </Text>
                    </View>
                ) : (
                    <Block>
                        <View
                            className="d-bottom-addcart"
                            onClick={() => {
                                if (!util.allowClick() || !loaded) {
                                    return
                                }
                                if (isSoldOut || util.isEmpty(productInfo.Id)) {
                                    return
                                }
                                specificPannelRef.current?.openFor(2)
                            }}
                        >
                            加入购物车
                        </View>
                        <View className="d-bottom-buy" onClick={() => {

                            if (!util.allowClick() || !loaded) {
                                return
                            }
                            if (isSoldOut || util.isEmpty(productInfo.Id)) {
                                return
                            }
                            specificPannelRef.current?.openFor(3)
                        }}>
                            立即购买
                        </View>
                    </Block>
                )}
            </View>
        </View>
        {/* 规格选择面板组件 */}
        <SpecificPannel
            ref={specificPannelRef}
            productInfo={productInfo}
            timeCountdown={!!timeCountDown?.enable}
            onAddCartSuccess={(info) => {
                var pictureUrl = info.pictureUrl
                setAddCartProductUrl(pictureUrl)
                setShowAddCardAnimate(true);
                setTimeout(function () {
                    setShowAddCardAnimate(false)
                }, 1000)
            }}
            onSpecificChange={(info) => {
                setUserSelectSpecific(info)
            }}
        />
        {/* 参数面板 */}
        <MetaListPanel ref={metaListPanelRef} />
        {/* 加购动画 */}
        <Image
            src={addCartProductUrl}
            className={
                'add-cart-pic ' +
                (showAddCartAimate ? 'add-cart-pic-animate' : '')
            }
        ></Image>
    </View>
}

export default Detail;